import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const INVITE_STORAGE_KEY = 'browmie_invite';
export const POST_LOGIN_REDIRECT_KEY = 'browmie_post_login_redirect';
export const REGISTRATION_RETURN_KEY = 'browmie_registration_return';

const validInviteCode = (value) => /^[A-Za-z0-9]{4,16}$/.test(String(value || ''));

// Invite links authenticate the friend before shopping. The attribution itself
// remains browser-local until checkout, where the backend binds it to the
// authenticated customer's first paid order.
export default function FriendInviteGate() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const inviteCode = new URLSearchParams(location.search).get('invite');
    if (!validInviteCode(inviteCode)) return;

    const normalizedCode = inviteCode.toUpperCase();
    try {
      localStorage.setItem(INVITE_STORAGE_KEY, JSON.stringify({ code: normalizedCode, at: Date.now() }));
      localStorage.setItem(POST_LOGIN_REDIRECT_KEY, '/marketplace');
      localStorage.setItem(REGISTRATION_RETURN_KEY, '/marketplace');
    } catch { /* storage unavailable — checkout cannot retain attribution */ }

    // Keep old shared links (/?invite=CODE) working while newly generated links
    // point directly to /account?invite=CODE.
    if (location.pathname === '/') {
      navigate(`/account?invite=${encodeURIComponent(normalizedCode)}`, { replace: true });
    }
  }, [location.pathname, location.search, navigate]);

  return null;
}
